export default "__VITE_PUBLIC_ASSET__db37ad46__"